export const GRID_SIZE = 10;

export const SHIPS = [
  { name: 'Carrier', size: 5, colour: 'bg-purple-600' },
  { name: 'Battleship', size: 4, colour: 'bg-blue-600' },
  { name: 'Cruiser', size: 3, colour: 'bg-green-600' },
  { name: 'Submarine', size: 3, colour: 'bg-yellow-600' },
  { name: 'Destroyer', size: 2, colour: 'bg-red-600' },
];

// Create empty grid
export const createEmptyGrid = () =>
  Array(GRID_SIZE).fill(null).map(() => Array(GRID_SIZE).fill(null));

// Check if ship placement is valid
export const isValidPlacement = (grid, row, col, size, isHorizontal) => {
  for (let i = 0; i < size; i++) {
    const r = isHorizontal ? row : row + i;
    const c = isHorizontal ? col + i : col;

    if (r >= GRID_SIZE || c >= GRID_SIZE) return false;
    if (grid[r][c] !== null) return false;
  }
  return true;
};

// Place ship on grid
export const placeShip = (grid, row, col, shipIndex, isHorizontal) => {
  const newGrid = grid.map(r => [...r]);
  const ship = SHIPS[shipIndex];

  for (let i = 0; i < ship.size; i++) {
    const r = isHorizontal ? row : row + i;
    const c = isHorizontal ? col + i : col;
    newGrid[r][c] = { shipIndex, segment: i, isHorizontal };
  }

  return newGrid;
};

// Randomly place all ships
export const randomPlacement = () => {
  let grid = createEmptyGrid();

  for (let shipIndex = 0; shipIndex < SHIPS.length; shipIndex++) {
    const ship = SHIPS[shipIndex];
    let placed = false;
    let attempts = 0;

    while (!placed && attempts < 100) {
      const isHorizontal = Math.random() > 0.5;
      const maxRow = isHorizontal ? GRID_SIZE : GRID_SIZE - ship.size;
      const maxCol = isHorizontal ? GRID_SIZE - ship.size : GRID_SIZE;

      const row = Math.floor(Math.random() * maxRow);
      const col = Math.floor(Math.random() * maxCol);

      if (isValidPlacement(grid, row, col, ship.size, isHorizontal)) {
        grid = placeShip(grid, row, col, shipIndex, isHorizontal);
        placed = true;
      }
      attempts++;
    }
  }

  return grid;
};

// Check if all ships are sunk
export const checkAllSunk = (grid, hits) => {
  for (let r = 0; r < GRID_SIZE; r++) {
    for (let c = 0; c < GRID_SIZE; c++) {
      if (grid[r][c] !== null && !hits[r][c]) {
        return false;
      }
    }
  }
  return true;
};

// Check if a ship is sunk (standalone function for use in callbacks)
export const checkShipSunk = (grid, hitRow, hitCol, currentHits) => {
  const cell = grid[hitRow][hitCol];
  if (!cell) return null;

  const { shipIndex, isHorizontal: shipHoriz } = cell;
  const ship = SHIPS[shipIndex];

  // Find ship start position
  let startRow = hitRow, startCol = hitCol;
  if (shipHoriz) {
    while (startCol > 0 && grid[startRow][startCol - 1]?.shipIndex === shipIndex) {
      startCol--;
    }
  } else {
    while (startRow > 0 && grid[startRow - 1][startCol]?.shipIndex === shipIndex) {
      startRow--;
    }
  }

  // Check if all segments are hit
  for (let i = 0; i < ship.size; i++) {
    const r = shipHoriz ? startRow : startRow + i;
    const c = shipHoriz ? startCol + i : startCol;
    if (r === hitRow && c === hitCol) continue; // This is the current hit
    if (!currentHits[r][c]) return null;
  }

  return ship.name;
};
